<template>
  <div class="c-main">
    <div class="c-main-top">
      <el-carousel
        ref="carousel"
        indicator-position="outside"
        :height="carouselHeight"
        autoplay
        arrow="always"
        @mousedown.native="handleMouseDown"
        @mousemove.native="handleMouseMove"
        @mouseup.native="handleMouseUp"
        @mouseleave.native="handleMouseUp"
        @touchstart.native="handleTouchStart"
        @touchmove.native="handleTouchMove"
        @touchend.native="handleTouchEnd"
      >
        <el-carousel-item v-for="(item, index) in homeLunbo.list" :key="index">
          <div class="carousel-play">
            <img
              :src="BASE_URL + item.imagesData[0]"
              alt="轮播图"
              class="carousel-img"
              @click="openVideoDialog(item)"
               draggable="false"
            />
            <button
              v-if="item.videoData && item.videoData.length > 0"
              class="play-btn"
              @click="openVideoDialog(item)"
            >
              <span class="play-icon"></span>
            </button>
          </div>
        </el-carousel-item>
      </el-carousel>

      <div class="titleFreeInquire">
        <div style="background: #005cef; color: #ffffff" @click="goFreeTrial">
          <span class="title-free">免费试用<span class="arrow"></span></span>
        </div>
        <div
          style="background: #ffffff; color: #005cef; border: 1px solid #005cef"
        >
          <span class="title-inquire"
            >咨询产品<span
              class="arrow"
              style="border: 2px solid #005cef"
            ></span
          ></span>
        </div>
      </div>
    </div>
    <div class="c-main-center">
      <div class="gradient">
        <div class="service">
          <p class="service-w">{{ homeTimeline.mainTitle }}</p>
          <p class="service-m">{{ homeTimeline.subTitle }}</p>
        </div>
        <div class="switch">
          <div class="switch-buttons">
            <!-- 循环生成按钮 -->
            <button
              v-for="(btn, index) in homeTimeline.list"
              :key="index"
              :class="['switch-btn', { active: currentIndex === index }]"
              @click="handleSwitch(index)"
            >
              {{ btn.tabTitle }}
            </button>
          </div>
        </div>
        <div class="timeline-wrapper">
          <!-- 左侧时间线（使用Element UI组件） -->

          <div class="timeline-left" style="float: left">
            <el-timeline @change="handleClick">
              <el-timeline-item
                v-for="(item, index) in currentTimelineList"
                :key="index"
                :color="index <= currentTimelineIndex ? '#005CEF' : ''"
                :class="index <= currentTimelineIndex ? 'red' : ''"
              >
                <div
                  class="timeline-content"
                  style="display: flex; position: relative"
                  @click="handleClick(index)"
                >
                  <span
                    class="item-title"
                    :style="{
                      color: currentTimelineIndex >= index ? '#005CEF' : '',
                    }"
                    >{{ index + 1 }} {{ item.timeTitle }}
                  </span>
                  <div
                    v-if="currentTimelineIndex == index"
                    style="
                      position: absolute;
                      left: 200px;
                      margin-top: 10px;
                      z-index: 10;
                    "
                  >
                    <div
                      class="tm-bg-blue"
                      style="
                        width: 120px;
                        height: 5px;
                        display: block;
                        border-radius: 3px 0px 0px 3px;
                      "
                    ></div>
                  </div>
                </div>
                <div
                  v-if="index == currentTimelineLength - 1"
                  style="height: 160px"
                ></div>
              </el-timeline-item>
            </el-timeline>

            <el-button
              class="experience-btn"
              type="primary"
              round
              @click="goFreeTrial"
            >
              立即体验 <i class="arrow"></i>
            </el-button>
          </div>

          <!-- 右侧内容展示区 -->
          <div
            class="timeline-right"
            style="float: right"
            v-if="
              homeTimeline.list &&
              homeTimeline.list[currentIndex] &&
              homeTimeline.list[currentIndex].list &&
              homeTimeline.list[currentIndex].list[currentTimelineIndex] &&
              homeTimeline.list[currentIndex].list[currentTimelineIndex]
                .imageUrls
            "
          >
            <div class="screen-display">
              <el-carousel
                indicator-position="none"
                arrow="never"
                :autoplay="false"
              >
                <el-carousel-item
                  v-for="(imgUrl, index) in homeTimeline.list[currentIndex]
                    .list[currentTimelineIndex].imageUrls"
                  :key="index"
                >
                  <img :src="BASE_URL + imgUrl" alt="" v-if="imgUrl" />
                </el-carousel-item>
              </el-carousel>
            </div>
            <div class="content-desc">
              <div
                v-for="(title, index) in [
                  homeTimeline.list[currentIndex].list[currentTimelineIndex],
                ]"
                :key="index"
              >
                <h3>{{ title.timeTitle }}</h3>
                <p style="display: flex; align-items: center; gap: 8px">
                  {{ title.timeDesc }}
                </p>
              </div>
            </div>
          </div>
        </div>

        <div class="why">{{ homeWhy.name }}</div>
        <div class="calculate">
          <img :src="BASE_URL + homeWhy.url" alt="" />
        </div>
        <div style="height: 102px"></div>
      </div>
      <div class="painPoint">{{ homePeople.mainTitle }}</div>
      <div class="technology">
        <!-- 角色列表区域 -->
        <ul class="item-list" v-if="homePeople.list.length">
          <li
            v-for="(item, index) in homePeople.list"
            :key="index"
            :data-type="item.type"
            :class="{ active: activeIndex === index }"
            @mouseenter="setActive(index)"
          >
            <h3>{{ item.subTitle }}</h3>
            <p >{{ item.subDescription }}</p>
          </li>
        </ul>

        <div
          class="image-container"
          v-if="activeRole"
          :data-type="activeRole.type"
        >
          <div
            class="img-box"
            v-for="(img, i) in activeRole.images"
            :key="i"
            :class="{
              active: hoveredIndex === i,
              left: hoveredIndex === i && i === 0,
              right: hoveredIndex === i && i === activeRole.images.length - 1,
            }"
            @mouseenter="hoveredIndex = i"
            @mouseleave="hoveredIndex = null"
          >
            <img :src="img.url" alt="" />

            <div class="overlay" v-if="hoveredIndex === i">
              <h4 class="overlay-title">{{ img.title }}</h4>
              <div class="line"></div>
              <p class="overlay-desc">{{ img.description }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="news-section">
        <!-- 标题区域 -->
        <h2 class="section-title">新闻动态</h2>

        <!-- 标签切换-->
        <div class="tab-nav">
          <span
            v-for="(tab, index) in tabList"
            :key="index"
            :class="['tab-item', { active: currentTab === index }]"
            @click="handleTabChange(index, tab.type)"
          >
            {{ tab.label }}
          </span>
        </div>

        <!-- 新闻列表 -->
        <div class="news-container">
          <!-- 大图新闻 -->
          <div
            class="news-card large-card"
            v-if="filterNewsList.length > 0"
            @click="goBigToDetail"
          >
            <img
              :src="BASE_URL + filterNewsList[0].infoImage"
              alt="新闻图片"
              class="news-img"
            />
            <div class="news-content">
              <h3 class="news-title">
                {{ filterNewsList[0].infoTitle || "" }}
              </h3>
              <div class="news-meta">
                <span class="publish-date">{{
                  filterNewsList[0].createDate.split(" ")[0] || ""
                }}</span>
                <div class="read-more">查看详情 →</div>
              </div>
            </div>
          </div>

          <!-- 小图新闻列表 -->
          <div class="small-news-list">
            <div
              class="news-cards small-card"
              v-for="(item, index) in filterNewsList.filter((_, i) => i > 0)"
              :key="index"
              @click="goToDetail(item)"
            >
              <img
                :src="BASE_URL + item.infoImage"
                alt="新闻图片"
                class="news-img"
              />
              <div class="news-content">
                <h3 class="news-title">{{ item.infoTitle || "" }}</h3>
                <div class="news-meta">
                  <span class="publish-date">{{
                    item.createDate.split(" ")[0] || ""
                  }}</span>
                  <div class="read-more">
                    查看详情 →
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 更多按钮 -->
        <button @click="moreNew" class="more-btn">
          更多新闻 <i class="arrow"></i>
        </button>
      </div>
      <div class="industry-experience">
        <!-- 标题区域 -->
        <h2 class="section-title">{{ homeBrand.brandTitle }}</h2>

        <!-- 品牌LOGO展示网格 -->
        <div class="brand-container">
          <div
            class="brand-item"
            v-for="(imgUrl, index) in homeBrand.list"
            :key="index"
          >
            <img
              :src="BASE_URL + imgUrl.imageUrls"
              alt=""
              v-if="imgUrl.imageUrls"
            />
          </div>
        </div>

        <!-- 查看更多按钮 -->
        <button @click="goLook" class="more-btn">
          查看更多 <i class="arrow"></i>
        </button>
      </div>
    </div>
    <el-dialog
      title="视频播放"
      :visible.sync="centerDialogVisible"
      width="50%"
      center
      :close-on-click-modal="false"
      :append-to-body="true"
    >
      <!-- 中间内容：视频（固定宽高比例，适配弹窗） -->
      <div class="video-wrapper">
        <video
          :src="BASE_URL + videoModalDataUrl"
          controls
          class="video-player"
          preload="auto"
        >
          您的浏览器不支持 HTML5 视频播放，请升级浏览器后重试。
        </video>
      </div>

      <!-- 底部按钮 -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleCloseDialog">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import play from "../../assets/play.png";
import { listInfo, getConf } from "../../api/article";
export default {
  name: "Home",
  data() {
    return {
      homePeople: { list: [] },
      homeWhy: {},
      homeTimeline: {
        mainTitle: "",
        subTitle: "",
        list: [
          {
            tabTitle: "",
            list: [
              {
                timeDesc: "",
                timeIconUrl: "",
                imageUrls: [],
              },
            ],
          },
        ],
      },
      homeCard: { list: [] },
      homeLunbo: { list: [] },
      homeConf: {
        articleContent: "",
      },
      centerDialogVisible: false,
      currentRoleIndex: 0,
      newsList: [],
      BASE_URL: process.env.VUE_APP_API_BASE_URL,
      buttonList: ["台账管理", "工艺管理", "生产排程", "项目管理", "车间管理"],
      currentIndex: 0,
      currentTimelineIndex: 0, // 当前选中项索引
      timer: null, // 定时器实例
      autoPlayInterval: 3000, // 自动切换间隔（3秒，可修改）
      timelineData: [
        {
          num: "01",
          title: "模具履历管理",
          desc: "通过二维码对模具进行信息管理，随时掌控模具状态、位置，实现无纸化办公",
          imgUrl: play,
        },
        {
          num: "02",
          title: "维修流程",
          desc: "标准化维修流程，自动记录维修记录和费用，生成维修统计报表",
          imgUrl: play,
        },
        {
          num: "03",
          title: "模具仓及备用件",
          desc: "实时监控模具库存和备用件状态，低库存自动预警，提高库存周转率",
          imgUrl: play,
        },
        {
          num: "04",
          title: "详细计划与记录",
          percent: "26.67%",
          desc: "制定详细的生产计划，自动记录执行过程，偏差实时提醒",
          imgUrl: play,
        },
        {
          num: "05",
          title: "试模与验收",
          desc: "在线记录试模参数和结果，自动生成验收报告，支持电子签名确认",
          imgUrl: play,
        },
      ],
      currentTab: 0, // 当前标签索引
      currentInfoType: 1, // 当前选中的资讯类型（默认1=企业动态）
      tabList: [
        { label: "企业动态", type: 1 }, // 对应 infoType=1
        { label: "行业资讯", type: 2 }, // 对应 infoType=2
        { label: "媒体报道", type: 3 }, // 对应 infoType=3
      ],
      homeBrand: { list: [] },
      videoModalDataUrl: "",

      activeIndex: 0, // 默认选中第一个
      roles: [],
      // 图片选中
      hoveredIndex: null,
      carouselHeight: "auto",
        startX: 0,
      isDragging: false,
    };
  },
  filters: {
    setText(val) {
      return val
        .replace(/<(p|div)[^>]*>(<br\/?>|&nbsp;)<\/\1>/gi, "\n")
        .replace(/<br\/?>/gi, "\n")
        .replace(/<[^>/]+>/g, "")
        .replace(/(\n)?<\/([^>]+)>/g, "")
        .replace(/\u00a0/g, " ")
        .replace(/&nbsp;/g, " ")
        .replace(/<img[^>]+src\\s*=\\s*['"]([^'"]+)['"][^>]*>/g, "")
        .replace(/<\/?(img|table)[^>]*>/g, "") // 去除图片和表格
        .replace(/<\/?(a)[^>]*>/g, ""); //  去除a标签
    },
  },
  computed: {
    filterNewsList() {
      const { currentInfoType, newsList } = this;
      return newsList.filter((f) => f.infoType == currentInfoType);
    },
    currentTimelineList() {
      const tabs = this.homeTimeline && this.homeTimeline.list;
      const currentTab = tabs && tabs[this.currentIndex];
      return (currentTab && currentTab.list) || [];
    },
    currentTimelineLength() {
      return this.currentTimelineList.length;
    },
    activeRole() {
      return this.homePeople.list[this.activeIndex] || null;
    },
  },
  created() {},
  mounted() {
    this.fetchNewsData();
    // 启动自动切换
    this.startAutoPlay();
    this.fetchHomeConf();
    this.setCarouselHeight();
    window.addEventListener("resize", this.setCarouselHeight);
  },
  beforeUnmount() {
    // 页面销毁时清除定时器，避免内存泄漏
    this.clearAutoPlay();
    window.removeEventListener("resize", this.setCarouselHeight);
  },
  watch: {
    centerDialogVisible(val) {
      if (!val) {
        const video = document.querySelector(".video-player");
        if (video) video.pause();
      }
    },
  },
  methods: {
    setCarouselHeight() {
      // 页面宽度
      const width = window.innerWidth;
      // 以比例计算高度: 768/1920 ≈ 0.4
      const scaledHeight = width * 0.4;
      // 不要超过768
      this.carouselHeight = Math.min(scaledHeight, 768) + "px";
    },
    setActive(index) {
      if (this.activeIndex !== index) {
        this.activeIndex = index;
      }
    },
    openVideoDialog(e) {
      const { videoData = [] } = e;
      if (videoData.length > 0) {
        this.videoModalDataUrl = videoData[0];
        this.centerDialogVisible = true;
      }
    },
       // ==== 加在 methods 里 ====
    handleMouseDown(e) {
      this.startX = e.clientX;
      this.isDragging = true;
    },
    handleMouseMove() {
      if (!this.isDragging) return;
    },
    handleMouseUp(e) {
      if (!this.isDragging) return;
      const diff = e.clientX - this.startX;
      this.isDragging = false;
      if (Math.abs(diff) > 50) {
        if (diff > 0) this.$refs.carousel.prev();
        else this.$refs.carousel.next();
      }
    },
    handleTouchStart(e) {
      this.startX = e.touches[0].clientX;
      this.isDragging = true;
    },
    handleTouchMove() {
      if (!this.isDragging) return;
    },
    handleTouchEnd(e) {
      if (!this.isDragging) return;
      const endX = e.changedTouches[0].clientX;
      const diff = endX - this.startX;
      this.isDragging = false;
      if (Math.abs(diff) > 50) {
        if (diff > 0) this.$refs.carousel.prev();
        else this.$refs.carousel.next();
      }
    },
    async fetchHomeConf() {
      try {
        const response = await getConf();
        this.homeConf = JSON.parse(response.data.logo) || {};
        this.homeLunbo = JSON.parse(response.data.lunbo) || { list: [] };
        this.homeLunbo.list = this.homeLunbo.list.filter(
          (f) => f.imagesData.length > 0 || f.videoData.length > 0
        );
        this.homeCard = JSON.parse(response.data.card) || { list: [] };
        this.homeTimeline = JSON.parse(response.data.timeline) || {
          list: [{ list: [] }],
        };
        this.currentTimelineIndex = 0;
        this.startAutoPlay();
        this.homeWhy = JSON.parse(response.data.why) || {};
        const peopleData = JSON.parse(response.data.people) || { list: [] };
        this.homePeople = {
          ...peopleData,
          list: (peopleData.list || []).map((item) => {
            const images = (item.imageUrls || []).map((img) => ({
              url: this.BASE_URL + img.url,
              title: img.title || "",
              description: img.description || "",
            }));

            return {
              ...item,
              images,
              type:
                images.length === 1
                  ? "single"
                  : images.length > 1
                  ? "multi"
                  : "",
            };
          }),
        };
        console.log("this.homeLunbo :", this.homeLunbo);
        console.log("this.homeLunbo :", this.homeLunbo);
        console.log("this.homeLunbo :", this.homeLunbo);

        this.homeBrand = JSON.parse(response.data.brand) || {};
        console.log(this.homeBrand, "brandList");
      } catch (error) {
        console.error("页面初始化获取配置失败", error);
      }
    },
    startAutoPlay() {
      this.clearAutoPlay();
      if (this.currentTimelineLength <= 1) return;
      this.timer = setInterval(() => {
        const nextIndex =
          (this.currentTimelineIndex + 1) % this.currentTimelineLength;
        this.currentTimelineIndex = nextIndex;
      }, this.autoPlayInterval);
    },

    // 清除定时器
    clearAutoPlay() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    // 关闭弹窗时暂停视频
    handleCloseDialog() {
      const video = document.querySelector(".video-player");
      if (video) video.pause(); // 防止后台继续播放
      this.centerDialogVisible = false;
      this.currentVideoUrl = ""; // 重置
    },
    goToDetail(item) {
      this.$router.push({ path: `/newdetails/${item.infoId}`,query: { type: 'news', }  });
    },
    goBigToDetail() {
      this.$router.push({
        path: `/newdetails/${this.filterNewsList[0].infoId}`,
        query: { type: 'news', } 
      });
    },
    handleTabChange(index, type) {
      this.currentTab = index; // 更新当前标签索引
      this.currentInfoType = type; // 更新当前资讯类型
      this.currentPage = 1; // 切换分类重置页码（可选，避免跨分类分页混乱）
      this.fetchNewsData(); // 重新请求对应分类的新闻
    },
    goFreeTrial() {
      this.$router.push({ name: "freeTrial" });
    },
    moreNew() {
      this.$router.push({ name: "newsUpdates" });
    },
    goLook() {
      this.$router.push({ name: "Customer" });
    },
    handleSwitch(index) {
      if (this.currentIndex === index) return;
      this.currentIndex = index;
      this.handleClick(0);
    },
    handleClick(index) {
      if (this.currentTimelineLength <= 0) {
        this.currentTimelineIndex = 0;
        this.clearAutoPlay();
        return;
      }
      this.currentTimelineIndex = Math.min(
        Math.max(index, 0),
        this.currentTimelineLength - 1
      );
      this.clearAutoPlay();
      if (this.currentTimelineLength > 1) {
        this.startAutoPlay();
      }
    },
    async fetchNewsData() {
      try {
        this.isLoading = true;
        const requestParams = {
          pageNum: 1,
          numPerPage: 999,
        };
        const res = await listInfo(requestParams, {
          infoType: this.currentInfoType,
        });
        if (res.code == 0) {
          console.log(res);
          this.newsList = (res.rows || []).slice(0, 4);
          this.totalCount = res.total || res.rows.length;
        } else {
          this.newsList = [];
          this.totalCount = 0;
          this.$message.warning("未获取到新闻数据");
        }
      } catch (error) {
        console.error("新闻数据请求失败：", error);
        this.$message.error("网络异常，请稍后重试");
        this.newsList = [];
        this.totalCount = 0;
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>
 

<style lang="scss" scoped>
@mixin backgroundImage($url) {
  background-image: url($url);
  background-repeat: no-repeat;
  background-size: 100%;
}
.c-main {
  display: flex;
  flex-direction: column;

  .title-group {
    width: 840px;
    height: 151px;
    text-align: center;
    margin-top: 39px;
    margin-left: auto;
    margin-right: auto;
    text-shadow: 0px 6px 2px #ccd5f2;
    font-weight: bold;
    letter-spacing: 5px;
    font-weight: bold;
    font-size: 54px;
    color: #000219;
  }
  .titleFreeInquire {
    width: 840px;
    margin-left: auto;
    margin-right: auto;
    display: flex;
    justify-content: center;
    gap: 20px;
    margin-top: 37px;
    div {
      width: 160px;
      height: 48px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 4px 4px 4px 4px;
      box-shadow: 0px 6px 24px 1px rgba(0, 92, 239, 0.4);

      .title-free,
      .title-inquire {
        font-size: 18px;
        display: flex;
        align-items: center;
        cursor: pointer; /* 核心：hover 时变成手指指针 */
        transition: color 0.3s ease; /* 可选：颜色过渡动画，更流畅 */
      }

      .arrow {
        /* 补充箭头样式（如白色圆圈） */
        width: 16px;
        height: 16px;
        border: 2px solid #ffffff;
        border-radius: 50%;
        margin-left: 8px;
        display: inline-block;
      }
    }
  }
  .carousel-play {
    width: 100%;
    height: 100%;
    position: relative;
    overflow: hidden;
  }

  .carousel-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 3px;
    box-shadow: 0 10px 45px rgba(189, 203, 229, 0.5);
  }

  /* 播放按钮 统一大小 */
  .play-btn {
    width: 80px;
    height: 80px;
    background: #334142;
    border: 2px solid #ffffff;
    border-radius: 50%;
    box-shadow: 0 8px 24px rgba(59, 99, 191, 0.5);
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 99;
    transition: all 0.3s ease;
  }

  .play-btn:hover {
    background-color: #fff;
  }

  .play-icon {
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 20px 0 20px 34px;
    border-color: transparent transparent transparent #ffffff;
    margin-left: 4px;
  }

  /* Carousel 左右箭头统一大小与风格 —— 无放大版 */
  ::v-deep(.el-carousel__arrow) {
    width: 80px;
    height: 80px;
    background: rgba(0, 0, 0, 0.2); /* 默认半透明背景 */
    border-radius: 50%;
    color: #000; /* 黑色箭头 */
    font-size: 28px;
    transition: background 0.3s ease, color 0.3s ease, opacity 0.3s ease;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
    backdrop-filter: blur(6px);
  }

  /* hover 状态增强 */
  ::v-deep(.el-carousel__arrow:hover) {
    background: rgba(0, 0, 0, 0.7); /* 提高透明度 */
    color: #fff; /* 悬停时箭头变白色 */
    /* ❌ 不再有 transform: scale() */
  }

  ::v-deep(.el-carousel__arrow--left) {
    left: 60px;
  }

  ::v-deep(.el-carousel__arrow--right) {
    right: 60px;
  }

  ::v-deep(.el-carousel__arrow i) {
    font-weight: bold;
    font-size: 28px;
  }
}
.c-main-center {
  position: relative;
  .gradient {
    background-image: url("../../assets/gradient.png");
    background-repeat: no-repeat; /* 防止背景图重复 */
    background-size: cover; /* 背景图自适应容器大小 */
    background-position: center; /* 背景图居中显示 */
  }
  position: relative;
  .analyze {
    position: absolute;
    left: 320px;
    top: -119px;
    ul {
      display: flex;
      justify-content: center;
      gap: 24px;
      .analyze-item {
        width: 424px;
        height: 238px;
        background: #ffffff;
        box-shadow: 16px 8px 50px 1px rgba(41, 91, 206, 0.16);
        border-radius: 8px 8px 8px 8px;
        border-radius: 8px;
        display: flex;
        align-items: flex-start;
        padding: 24px;
        box-sizing: border-box;
        position: relative;
        align-items: center;

        .item-icon {
          width: 150px;
          height: 150px;
          margin-right: 24px;
          border-radius: 8px;
        }

        .item-content {
          letter-spacing: 2px;
          h3 {
            font-size: 20px;
            color: #000a25;
            margin-bottom: 12px;
            font-weight: bold;
          }
          p {
            font-size: 14px;
            color: #666;
            margin: 4px 0;
          }
        }
        .num {
          position: absolute;
          bottom: 12px;
          right: 12px;
          width: 59px;
          height: 65px;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
  }
}
.service {
  margin-top: 70px;
  text-align: center;
  .service-w {
    font-weight: bold;
    font-size: 40px;
    color: #000a25;
  }
  .service-m {
    margin-top: 12px;
    margin-bottom: 24px;
    font-weight: 400;
    font-size: 24px;
    color: #858a9d;
  }
}
.switch {
  width: 738px;
  height: 58px;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  align-items: center;
  justify-content: space-around;
  border-radius: 29px;
  margin-bottom: 24px;
  background: #eff4fb;
  border-radius: 55px 55px 55px 55px;
  border: 2px solid #f6faff;
}

.switch-buttons {
  display: flex;
  align-items: flex-end;
  justify-content: center;
  gap: 8px;
}

.switch-btn {
  width: 138px;
  height: 40px;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  color: #000a25;
  background: #eff4fb;
}

.switch-btn.active {
  color: #005cef;
  background: linear-gradient(
    180deg,
    #ffffff 0%,
    #f5f9ff 0%,
    #f9fcff 43%,
    #ffffff 100%
  );
  box-shadow: 0px 3px 16px 1px rgba(115, 154, 188, 0.16);
  border-radius: 21px 21px 21px 21px;
  border: 2px solid #ffffff;
}

.switch-btn:hover:not(.active) {
  background-color: #e6f2ff;
}
.timeline-wrapper {
  width: 1320px;
  height: 602px;
  margin: 0 auto;
  padding: 60px 40px;
  box-sizing: border-box;
  display: flex;
  gap: 80px;
  position: relative;
  background-image: url("../../assets/carousel2.png");
  background-repeat: no-repeat; /* 防止背景图重复 */
  background-size: cover; /* 背景图自适应容器大小 */
  background-position: center; /* 背景图居中显示 */
  position: relative;
}
/* 左侧时间线样式 */
.timeline-left {
  width: 200px;
  .el-timeline {
    padding-left: 0;

    .el-timeline-item {
      padding-bottom: 40px;
      cursor: pointer;
      position: relative;

      // &::before {
      //   left: 15px;
      //   height: calc(100% - 30px);
      //   background-color: #bfd8f3;
      // }
      .el-timeline-item__timestamp {
        width: 30px;
        height: 30px;
        min-width: auto;
        border: 2px solid #005cef;
        border-radius: 50%;
        color: #005cef;
        font-weight: bold;
        font-size: 14px;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #fff;
        margin-right: 16px;
        z-index: 2;
      }

      // 步骤标题容器
      .el-timeline-item__content {
        top: 0;
        padding: 0;
        margin-left: 16px;
      }

      // 步骤标题文本
      .item-title {
        font-size: 16px;
        color: #333;
        transition: all 0.3s ease;
      }

      // 选中状态样式
      &.active {
        .el-timeline-item__timestamp {
          background-color: #005cef;
          color: #fff;
        }
        .item-title {
          color: #005cef;
          font-weight: bold;
        }
        &::before {
          background-color: #005cef;
        }
      }

      // 最后一项去除底部间距和连接线
      &:last-child {
        padding-bottom: 0;
        &::before {
          display: none;
        }
      }
    }
  }

  // 立即体验按钮
  .experience-btn {
    width: 160px;
    height: 48px;
    padding: 8px 24px;
    border-color: #005cef;
    font-size: 18px;
    display: flex;
    align-items: center;
    background: #005cef;
    box-shadow: 0px 6px 24px 1px rgba(0, 92, 239, 0.4);
    border-radius: 4px 4px 4px 4px;
    position: absolute;
    left: 70px;
    bottom: 25px;

    &:hover {
      background-color: #0047cc;
      border-color: #0047cc;
    }
    .arrow {
      /* 补充箭头样式（如白色圆圈） */
      width: 16px;
      height: 16px;
      border: 2px solid #ffffff;
      border-radius: 50%;
      margin-left: 8px;
      display: inline-block;
    }
  }
}

/* 右侧内容展示样式 */
.timeline-right {
  margin-left: 180px;

  .screen-display {
    width: 760px;
    height: 436px;
    background: #ccc9c9;
    box-shadow: 0px 0px 24px 1px rgba(107, 127, 172, 0.35);
    border: 8px solid #ffffff;
    opacity: 0.8;
    border-radius: 8px;

    .screen-img {
      width: 100%;
      height: 100%;
      border-radius: 16px;
    }
  }

  .content-desc {
    margin-top: 30px;

    h3 {
      font-size: 24px;
      color: #000a25;
      margin: 0 0 12px;
    }

    p {
      font-size: 14px;
      color: #666;
      line-height: 1.6;
      margin: 0;
      max-width: 600px;
    }
  }
}

.why {
  font-weight: bold;
  font-size: 40px;
  color: #000a25;
  line-height: 28px;
  text-align: center;
  margin-top: 57px;
}
.calculate {
  width: 1186px;
  height: 520px;
  margin-top: 57px;
  margin-left: auto;
  margin-right: auto;
  img {
    width: 100%;
    height: 100%;
  }
}
.painPoint {
  font-weight: bold;
  font-size: 40px;
  color: #000a25;
  line-height: 28px;
  text-align: center;
  margin-top: 66px;
}
.technology {
  padding: 40px 0;
  margin-top: 30px;
  .item-list {
    display: flex;
    justify-content: center;
    list-style: none;
    padding: 0;
    margin: 0;
  }
  .item-list li {
    width: 280px;
    height: 90px;
    padding: 10px 15px;
    box-sizing: border-box;
    position: relative;
    background: #fff;
    color: #000;
    transition: all 0.4s ease;
    cursor: pointer;
    overflow: hidden;
    text-align: center;
  }

  /* 蓝条动画 */
  .item-list li::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 3px;
    background-color: #005cef;
    transform: scaleX(0);
    transform-origin: center;
    transition: transform 0.4s ease;
  }
  .item-list li:hover::before,
  .item-list li.active::before {
    transform: scaleX(1);
  }

  /* 分隔线 */
  .item-list li:not(:last-child)::after {
    content: "";
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 1px;
    height: 60%;
    background-color: #ccc;
  }

  /* 标题 */
  .item-list h3 {
    font-size: 20px;
    font-weight: 700;
    margin: 0 0 5px;
    transition: color 0.3s ease;
  }

  /* 描述 */
  .item-list p {
    margin: 0;
    font-size: 14px;
    color: #666;
    transition: color 0.3s ease;
  }

  /* hover + active 样式相同 */
  .item-list li:hover,
  .item-list li.active {
    border-top-color: #005cef;
    background: linear-gradient(to bottom, #caddfc, #ffffff);
    color: #000;
  }
  .item-list li:hover h3,
  .item-list li.active h3 {
    color: #005cef;
  }

  /* 图片模块 */
  .image-container {
    display: flex;
    gap: 40px;
    height: 360px;
    width: 100%;
    max-width:1320px;
    margin: 20px auto;
  }

  .img-box {
    flex: 1 1 0;
    transition: all 0.25s ease;
    overflow: hidden;
    position: relative; /* 为遮罩定位 */
  }

  .img-box img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: all 0.25s ease;
  }

  /* 宽度放大 */
  .img-box.active {
    flex: 1.2 1 0;
  }

  .img-box.left.active {
    transform-origin: left center;
  }

  .img-box.right.active {
    transform-origin: right center;
  }

  .img-box.active:not(.left):not(.right) {
    transform-origin: center center;
  }

  /* 图片缩放 */
  .img-box.active img {
    transform: scale(1.05);
  }

  /* 遮罩层样式 */
  .overlay {
    position: absolute;
    inset: 0;
    background: rgba(0, 0, 0, 0.4);
    color: #fff;
    padding: 16px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start; /* ✅ 改这里：内容从上往下排列 */
    align-items: flex-start;
    opacity: 0;
    transform: translateY(10px);
    transition: all 0.3s ease;
  }

  .img-box.active .overlay {
    opacity: 1;
    transform: translateY(0);
  }

  .overlay-title {
    font-size: 20px;
    font-weight: bold;
    margin: 0;
    padding-left: 20px;
    margin-bottom: 20px;
  }
  .line {
    width: 100%; /* 横线长度占满遮罩层宽度 */
    height: 1px; /* 横线厚度 */
    background-color: rgba(255, 255, 255, 0.6); /* 白色半透明线 */
    margin: 8px 0; /* 上下间距 */
  }

  .overlay-desc {
  font-size: 16px;
  line-height: 1.4;
  margin: 0;
  white-space: pre-wrap; /* 保留换行和空格 */
  max-height: 270px; /* 根据需要调整高度 */
  overflow-y: auto;  /* 超出时显示滚动条 */
  scrollbar-width: thin; /* Firefox: 缩小滚动条宽度 */
  scrollbar-color: rgba(255,255,255,0.4) transparent; /* Firefox: 设置滚动条颜色 */
  width: 100%;
}

/* 美化滚动条，仅针对 WebKit 浏览器 */
.overlay-desc::-webkit-scrollbar {
  width: 4px; /* 更细的滚动条 */
}

.overlay-desc::-webkit-scrollbar-thumb {
  background-color: rgba(255, 255, 255, 0.4); /* 半透明白色滑块 */
  border-radius: 4px; /* 圆角，使滑块更小更柔和 */
}

.overlay-desc::-webkit-scrollbar-track {
  background: transparent; /* 背景透明，让只显示滑块 */
}

/* 可选：滚动时增强可见性 */
.overlay-desc:hover::-webkit-scrollbar-thumb {
  background-color: rgba(255, 255, 255, 0.6);
}


}

.news-section {
  background-color: #f2f6fc;
  padding: 60px 0;
  box-sizing: border-box;

  // 标题样式
  .section-title {
    text-align: center;
    font-size: 28px;
    color: #000a25;
    margin: 0 0 32px;
    font-weight: bold;
  }

  // 标签导航
  .tab-nav {
    display: flex;
    justify-content: center;
    gap: 40px;
    margin: 0 0 40px;

    .tab-item {
      font-size: 18px;
      color: #666;
      cursor: pointer;
      padding-bottom: 6px;
      border-bottom: 2px solid transparent;
      transition: all 0.3s ease;

      &.active {
        color: #005cef;
        border-bottom-color: #005cef;
        font-weight: bold;
      }
    }
  }

  // 新闻容器
  .news-container {
    display: flex;
    gap: 30px;
    margin: 48px  0;
    justify-content: center; /* 水平居中 */
    // 大图新闻卡片
    .large-card {
      width: 782px;
    }

    // 小图新闻列表
    .small-news-list {
      display: flex;
      flex-direction: column;
      gap: 20px;
      width: 518px;
    }

    // 通用新闻卡片样式
    .news-card {
      width: 782px;
      padding: 12px;
      background-color: #fff;
      border-radius: 8px;
      overflow: hidden;
      box-shadow: 0 3px 10px rgba(0, 0, 0, 0.08);
      transition: transform 0.3s ease;
      cursor: pointer;
      .news-content {
        margin-top: 18px;
        .news-title {
          font-size: 18px;
          color: #000a25;
          line-height: 1.4;
          display: inline;
        }

        .small-card .news-title {
          font-size: 16px;
        }

        .news-meta {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-top: 90px;

          .publish-date {
            font-size: 14px;
            color: #999;
          }

          .read-more {
            font-size: 14px;
            color: #005cef;
            text-decoration: none;

            &:hover {
              text-decoration: underline;
            }
          }
        }
      }
      .publish-date {
        font-size: 14px;
        color: #999;
      }
      .news-img {
        width: 742px;
        height: 280px;
        object-fit: cover;
      }

      .large-card .news-img {
        height: 280px;
      }
    }
    .news-cards {
      width: 518px;
      padding: 12px;
      box-sizing: border-box;
      background-color: #fff;
      border-radius: 8px;
      overflow: hidden;
      box-shadow: 0 3px 10px rgba(0, 0, 0, 0.08);
      transition: transform 0.3s ease;
      display: flex;
      cursor: pointer;

      .news-img {
        width: 265px;
        height: 116px;
        object-fit: cover;
      }

      .small-card .news-img {
        width: 265px;
        height: 116px;
        background-color: #666;
      }

      .news-content {
        flex: 1;
        min-width: 0;
        margin-left: 18px;
        .news-title {
          font-size: 18px;
          color: #000a25;
          line-height: 1.4;
          display: block;
          word-break: break-all;
        }

        .small-card .news-title {
          font-size: 16px;
        }

        .news-meta {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-top: 70px;

          .publish-date {
            font-size: 14px;
            color: #999;
          }

          .read-more {
            margin-left: 16px;
            font-size: 14px;
            color: #005cef;
            text-decoration: none;
            white-space: nowrap;

            &:hover {
              text-decoration: underline;
            }
          }
        }
      }

      // 小卡片布局
      .small-card {
        display: flex;
        align-items: center;
        gap: 12px;
      }
    }
  }

  // 更多按钮
  .more-btn {
    width: 160px;
    height: 48px;
    display: block;
    margin: 0 auto;
    padding: 10px 28px;
    background-color: #fff;
    color: #005cef;
    border: none;
    cursor: pointer;
    font-size: 16px;
    display: flex;
    align-items: center;
    gap: 8px;
    border: 1px solid #005cef;
    border-radius: 4px 4px 4px 4px;
    .arrow {
      /* 补充箭头样式（如白色圆圈） */
      width: 16px;
      height: 16px;
      border: 2px solid #005cef;
      border-radius: 50%;
      margin-left: 8px;
      display: inline-block;
    }
  }
}
.industry-experience {
  background-color: #ffffff;
  padding: 60px 20px;
  text-align: center;
  box-sizing: border-box;

  // 标题样式
  .section-title {
    font-size: 28px;
    color: #000a25;
    margin: 0 0 48px;
    font-weight: bold;
    letter-spacing: 0.5px;
  }

  // 品牌容器
  .brand-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start; /* 从左到右排列 */

    max-width: calc(264px * 5); /* 一行5个的总宽度 */
    margin: 0 auto 40px;
  }

  .brand-item {
    width: 264px;
    height: 120px;
    border-radius: 6px;
    overflow: hidden;
    background-color: #f8f8f8; /* 防止没图时占位 */
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .brand-item img {
    width: 100%;
    height: 100%;
    object-fit: contain; /* 图片保持比例缩放 */
    display: block;
  }

  // 查看更多按钮
  .more-btn {
    width: 160px;
    height: 48px;
    display: block;
    margin: 0 auto;
    padding: 10px 28px;
    background-color: #fff;
    color: #005cef;
    border: none;
    cursor: pointer;
    font-size: 16px;
    display: flex;
    align-items: center;
    gap: 8px;
    border: 1px solid #005cef;
    border-radius: 4px 4px 4px 4px;
    .arrow {
      /* 补充箭头样式（如白色圆圈） */
      width: 16px;
      height: 16px;
      border: 2px solid #005cef;
      border-radius: 50%;
      margin-left: 8px;
      display: inline-block;
    }
  }
}
/* 视频容器：适配弹窗宽度，固定宽高比（16:9 黄金比例） */
.video-wrapper {
  width: 100%;
  padding-top: 56.25%; /* 16:9 比例 = 9/16 = 56.25% */
  position: relative;
  border-radius: 8px;
  overflow: hidden;
  margin-bottom: 10px;
}

/* 视频播放器：填充容器，居中显示 */
.video-player {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover; /* 避免视频拉伸，裁剪多余部分 */
}

/* 可选：调整弹窗内边距和标题样式 */
::v-deep .el-dialog__body {
  padding: 20px !important;
  text-align: center; /* 确保视频容器居中（可选） */
}

::v-deep .el-dialog__title {
  font-size: 18px;
  font-weight: bold;
  color: #005cef;
}

::v-deep .dialog-footer {
  text-align: center;
}

::v-deep .red .el-timeline-item__tail {
  border-left: 2px solid #01cdfe !important;
}
::v-deep .el-carousel__container {
  position: relative;
  height: 528px;
}
::v-deep .el-carousel__button {
  width: 16px;
  height: 8px;
  background: #c5c9d5;
  border-radius: 4px 4px 4px 4px;
}
.tm-bg-blue {
  background-image: linear-gradient(to right, #005cef 0%, #f5f7fb 100%),
    linear-gradient(to right, #005cef 0%, #f5f7fb 100%) !important;
}
.c-main {
  width: 100%;
  overflow-x: hidden; // 治本：确保主容器不溢出
}
</style>
